import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { CubeBox, CubeContainer } from './css';
import { P } from '../../../theme/typography';
import { getSizeMeasurementAbbreviationString } from '../../../utils/func';

const Cube = ({
  width = 0, height = 0, length = 0, solid, measurementType,
}) => {
  const cubeWidth = width > 30 ? 300 : width < 10 ? 100 : width * 10;
  const cubeHeight = height > 30 ? 300 : height < 10 ? 100 : height * 10;
  const cubeLength = length > 30 ? 300 : length < 10 ? 100 : length * 10;
  const measurement = getSizeMeasurementAbbreviationString(measurementType);

  return (
    <CubeContainer className="text-center">
      <CubeBox
        className={solid && 'solid'}
        width={cubeWidth}
        height={cubeHeight}
        length={cubeLength}
      >
        <div className="after" />
        <div className="before" />
      </CubeBox>
      <P>
        {t('WidthMeasure')}
        :
        {' '}
        {width}
        {' '}
        {t(measurement)}
        {' '}
        - H:
        {' '}
        {height}
        {' '}
        {t(measurement)}
        {' '}
        - L:
        {' '}
        {length}
        {' '}
        {t(measurement)}
      </P>
      <P>{t('NotToScaleBoxHeading')}</P>
    </CubeContainer>
  );
};

Cube.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  length: PropTypes.number,
  solid: PropTypes.bool,
  measurementType: PropTypes.string,
};

export default Cube;
